<template>
  <main>
    <inncosys-breadcrumbs :history="pathHistory"></inncosys-breadcrumbs>
    <div class="row">
      <div class="col xl12">
        <div class="card-panel">
          <form action>
            <div class="row">
              <div class="col l6 input-field">
                <inncosys-select
                  :data-set-ready="true"
                  label="Indicadores a monitorear"
                  first-option-message="Seleccione"
                  :multiple="true"
                  v-model="indicadoresSeleccionados"
                >
                  <option
                    v-for="(value, key) in indicadores"
                    v-bind:key="key"
                    :value="key"
                  >{{value.name}}</option>
                </inncosys-select>
              </div>
              <div class="col l6 input-field">
                <inncosys-select
                  :data-set-ready="true"
                  label="Periodo"
                  first-option-message="Seleccione un periodo"
                  v-model="periodicidad"
                >
                  <option value="D">D Día</option>
                  <option value="W">W Semana</option>
                  <option value="M">M Mes</option>
                  <option value="Y">Y Año</option>
                </inncosys-select>
              </div>
            </div>
            <div class="row">
              <div v-if="periodicidad" class="col l3 input-field">
                <inncosys-date-picker :options="{}" v-model="fechaInicio" label="Fecha Inicio"></inncosys-date-picker>
              </div>

              <div v-if="periodicidad" class="col l3 input-field">
                <inncosys-date-picker label="Fecha Fin" :options="{}" v-model="fechaFin"></inncosys-date-picker>
              </div>
              <div v-if="periodicidad" class="col l6 input-field">
                <inncosys-sucursales-select v-model="sucursal"></inncosys-sucursales-select>
              </div>
            </div>
            <div class="row">
              <div class="col l12 input-field right-align">
                <button class="btn" @click="mostrarGrafica" type="button">Graficar</button>
              </div>
            </div>
          </form>
        </div>
        <button class="btn" v-show="graficaVisible">Exportar Indicadores</button>
      </div>
    </div>
    <div class="row">
      <div class="col xl12">
        <div class="card-panel" id="indicadoresChart" v-show="graficaVisible">dsd</div>
      </div>
    </div>
    <div class="row" v-if="mostrarCausaPlan">
      <div class="col xl12">
        <div class="card-panel">
          <h5>Causa y plan de acción</h5>
          <div class="row">
            <div class="col xl6">
              <h6>Causa</h6>
              <textarea
                v-if="causaPlanWriteMode"
                placeholder="El motivo fue que..."
                v-model="causaIndicador"
              ></textarea>
              <p v-if="causaPlanReadMode">{{causaIndicador}}</p>
            </div>
            <div class="col xl6">
              <h6>Plan de acción</h6>
              <textarea
                v-if="causaPlanWriteMode"
                placeholder="Se cambiara la forma en la que..."
                v-model="planIndicador"
              ></textarea>
              <p v-if="causaPlanReadMode">{{planIndicador}}</p>
            </div>
          </div>
          <button
            v-if="causaPlanReadMode"
            class="btn right"
            @click="causaPlanReadMode=false; causaPlanWriteMode=true;"
          >Editar</button>
          <button class="btn right" v-if="causaPlanWriteMode" @click="guardarCausaPlan">Guardar</button>
          <br>
          <br>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Breadcrumbs from "../../../components/commun/Breadcrumbs.vue";
import SucursalesSelectName from "../../../components/commun/SucursalesSelectName.vue";
import Select from "../../../components/commun/forms/Select.vue";
import DatePicker from "../../../components/commun/forms/DatePicker.vue";

import dateUtils from "../../../utils/date-utils.js";

import * as Highcharts from "highcharts";
import * as firebase from "firebase";
import { indicadoresController } from "../../../controllers/indicadores";
const moment = require("moment");
import { firestore } from "../../../main";
const indicadoresInstance = new indicadoresController();
export default {
  components: {
    inncosysBreadcrumbs: Breadcrumbs,
    inncosysSucursalesSelect: SucursalesSelectName,
    inncosysDatePicker: DatePicker,
    inncosysSelect: Select
  },
  data() {
    return {
      mostrarCausaPlan: false,
      graficaVisible: false,
      periodicidad: "",
      sucursal: "all",
      periodicidadNombres: {
        D: "Días",
        W: "Semanas",
        M: "Meses",
        Y: "Años"
      },
      fechaInicio: null,
      fechaFin: null,
      indicadores: indicadoresInstance.mapaIndicidadores,
      indicadoresSeleccionados: null,
      chart: null,
      pathHistory: [
        {
          name: "Inicio",
          route: "/"
        },
        {
          name: "Monitoreo",
          route: "/monitoreo"
        }
      ],
      causaIndicador: "",
      planIndicador: "",
      causaPlanReadMode: true,
      causaPlanWriteMode: false,
      registroIndicadorSeleccionado: {}
    };
  },

  methods: {
    guardarCausaPlan(indicador, sucursal, periodo, fecha, tipo, mensaje) {
      firestore
        .collection("causa-plan")
        .doc(this.registroIndicadorSeleccionado.indicador)
        .collection("registros")
        .doc(
          this.registroIndicadorSeleccionado.sucursal
            .replace(/ /g, "")
            .toLowerCase()
        )
        .collection(this.registroIndicadorSeleccionado.periodo)
        .doc(this.registroIndicadorSeleccionado.fecha)
        .set(
          {
            causa: this.causaIndicador,
            plan: this.planIndicador
          },
          { merge: true }
        )
        .then(() => {
          this.causaPlanWriteMode = false;
          this.causaPlanReadMode = true;
        });
    },
    abrirCausaPlan(indicador, fecha) {
      this.registroIndicadorSeleccionado = {
        indicador: indicador,
        fecha: fecha,
        periodo: this.periodicidad,
        sucursal: this.sucursal
      };
      this.mostrarCausaPlan = true;
      var vueInstance = this;
      firestore
        .collection("causa-plan")
        .doc(this.registroIndicadorSeleccionado.indicador)
        .collection("registros")
        .doc(
          this.registroIndicadorSeleccionado.sucursal
            .replace(/ /g, "")
            .toLowerCase()
        )
        .collection(this.registroIndicadorSeleccionado.periodo)
        .doc(this.registroIndicadorSeleccionado.fecha)
        .get()
        .then(function(doc) {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            vueInstance.causaIndicador = doc.data().causa;
            vueInstance.planIndicador = doc.data().plan;
            vueInstance.causaPlanReadMode = true;
            vueInstance.causaPlanWriteMode = false;
          } else {
            vueInstance.causaPlanReadMode = false;
            vueInstance.causaPlanWriteMode = true;
            vueInstance.causaIndicador = "";
            vueInstance.planIndicador = "";
          }
        })
        .catch(function(error) {
          console.log("Error getting document:", error);
        });
    },
    mostrarGrafica() {
      var seriesLength = this.chart.series.length;
      for (var i = seriesLength - 1; i > -1; i--) {
        this.chart.series[i].remove();
      }
      this.indicadoresSeleccionados.forEach(indicador => {
        indicadoresInstance.mapaIndicidadores[indicador]
          .action({
            periodos: this.periodos,
            periodicidad: this.periodicidad,
            fecha: this.fechaFin,
            sucursal: this.sucursal
          })
          .then(indicadorRes => {
            var serieReal = {
              name: indicadorRes.name,
              data: indicadorRes.real,
              yAxis: indicadorRes.axis,
              xAxis: 0
            };
            var serieBase = {
              name: indicadorRes.name + " PB",
              data: indicadorRes.pb,
              yAxis: indicadorRes.axis,
              xAxis: 1
            };
            console.log(indicadorRes, indicadorRes.id);
            if (indicadorRes.id === "facturacion") {
              serieReal.tooltip = {
                valueDecimals: 2,
                valuePrefix: "$",
                valueSuffix: " MXN"
              };
              serieBase.tooltip = {
                valueDecimals: 2,
                valuePrefix: "$",
                valueSuffix: " MXN"
              };
            }
            this.chart.addSeries(serieReal);
            this.chart.addSeries(serieBase);
          });
      });
      this.graficaVisible = true;
    }
  },
  created() {},
  computed: {
    periodoSeleccionado() {
      return this.periodicidadNombres[this.periodicidad];
    },
    periodos() {
      if (this.fechaInicio && this.fechaFin && this.periodicidad)
        return moment(this.fechaFin).diff(
          moment(this.fechaInicio),
          dateUtils.dateKeys[this.periodicidad]
        );
      else return 0;
    }
  },
  watch: {},
  mounted() {
    const vueInstance = this;

    const instances = M.FormSelect.init(this.$refs.periodosSelectEl);
    this.chart = Highcharts.chart("indicadoresChart", {
      title: {
        text: "Indicadores PROSIC"
      },
      xAxis: [
        {
          type: "category"
        },
        {
          type: "category"
        }
      ],
      yAxis: [
        {
          labels: {
            format: "{value:,.0f} MXN"
          },
          title: {
            text: "$ MXN"
          }
        },
        {
          labels: {
            format: ""
          },
          title: {
            text: "U"
          }
        },
        {
          labels: {
            format: "{value} %"
          },
          title: {
            text: "%"
          }
        }
      ],
      legend: {
        layout: "vertical",
        align: "right",
        verticalAlign: "middle"
      },

      plotOptions: {
        series: {
          label: {
            connectorAllowed: false
          },
          point: {
            events: {
              click(event) {
                 vueInstance.abrirCausaPlan(this.indicador, this.name);
              }
            }
          }
        }
      },
      series: []
    });
  }
};
</script>

<style scoped>
p {
  overflow: scroll;
}
</style>
